var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: { color: _vm.isBalancePaid ? "var(--green)" : "" },
      attrs: { id: "balance" },
    },
    [
      _c("table", { staticClass: "drop-shadow-sides" }, [
        _c("tr", [
          _c("td", { attrs: { id: "label" } }, [_vm._v("BALANCE")]),
          _c(
            "td",
            { attrs: { id: "value" } },
            [
              _c(
                "transition",
                { attrs: { name: "amount-drop-in", mode: "out-in" } },
                [
                  _c("div", { key: _vm.amount }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("toCurrency")(_vm.amount)) + " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }